import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignSummaryDto, SummarySectionDto } from '@models/job-request-summary-dto.interface';

@Component({
  selector: 'app-design-summary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './design-summary.component.html',
  styleUrl: './design-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DesignSummaryComponent {
  @Input() summary: DesignSummaryDto | null = null;

  protected readonly columns = [1, 2, 3];

  protected sectionsForColumn(column: number): SummarySectionDto[] {
    return (this.summary?.sections ?? [])
      .filter(section => section.column === column)
      .sort((a, b) => a.order - b.order);
  }

  protected trackBySection(_: number, section: SummarySectionDto): string {
    return section.key;
  }
}
